import { dispatch } from "../utilities/dom-events";
import { elementContext } from "./element";
var RenderEvent;
(function (RenderEvent) {
    RenderEvent["Render"] = "render-event";
})(RenderEvent || (RenderEvent = {}));
var noop = function () { };
var ɵ0 = noop;
var ɵ1 = function () {
    return {
        update: noop
    };
};
var renderContext = elementContext(ɵ1);
function defaultRenderer(template) {
    return function (host) {
        var result = template(host);
        return function (host, target) {
            target.innerHTML = result;
        };
    };
}
function requestUpdate(host) {
    var update = renderContext(host).update;
    update && update();
}
function render(renderer) {
    return {
        get: function (host) {
            var render = renderer(host);
            return function flush() {
                render(host, host.shadowRoot ? host.shadowRoot : host);
            };
        },
        connect: function (host, key, invalidate) {
            renderContext(host).update = function () { return invalidate(false); };
            return function () {
                invalidate(false);
                renderContext(host).update = noop;
            };
        },
        observe: function (host, flush) {
            flush();
            dispatch(host, RenderEvent.Render);
        }
    };
}
export { render, requestUpdate, defaultRenderer, RenderEvent };
export { ɵ0, ɵ1 };
//# sourceMappingURL=render.js.map